import {
  combineReducers,
  legacy_createStore as createStore,
  Reducer,
} from "redux";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // 默认使用localStorage
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { Config } from "@/reducers/config";
import { User } from "@/reducers/user";
import { Menu } from "@/reducers/menu";
import { Token } from "@/reducers/token";

const persistConfig = {
  key: 'robotRoot',
  storage,
  stateReconciler: autoMergeLevel2,
}

const rootReducer = combineReducers({
  User,
  Config,
  Menu,
  Token,
});

export type RootState = ReturnType<typeof rootReducer>;

const persistedReducer = persistReducer(persistConfig, rootReducer as Reducer);

let store = createStore(persistedReducer);
const persistor = persistStore(store);
const persistorStore = {
  persistor,
  store,
}

export default persistorStore;